/*
 * @Description: 限时倒计时
 * @Author: 9尘
 * @Date: 2018-11-26 17:49:56
 * @LastEditors: hongyao.lm
 * @LastEditTime: 2019-07-12 17:39:18
 *
 * @params {Boolean} reload 表示倒计时结束时是否刷新页面
 * @params {Func} onCountEnd 倒计时结束时触发的回调
 * @params {String} time 倒计时的时间
 * @params {Boolean} flag 表示是否显示天数
 * @params {Boolean} text 表示输出只有文字的格式，没有白底框
 */
import React, { Component } from 'react';
import { Flex } from 'antd-mobile';
import util from 'utils';
import './index.less';

/**
 * 默认颜色是白底，红字（主题色）（首页例子）
 */
class CountDown extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      // 倒计时, 字符串2018-10-10 10:00:00 或 倒计时差，秒
      countdownTime: this.props.time,
      date: '00',
      hour: '00',
      min: '00',
      sec: '00'
    };
    this.clearTimeMethod = null;
  }

  componentDidMount() {
    // reload 表示倒计时结束时是否刷新页面
    // onCountEnd为倒计时结束时触发的回调
    const { countdownTime } = this.state;
    const { reload, onCountEnd } = this.props;

    const data = util.getCountDown(util.exchangeTime(countdownTime), this.props.flag);
    const { date, hour, min, sec } = data;
    if (+date === 0 && +hour === 0 && +min === 0 && +sec === 0) {
      return;
    }

    const timer = setInterval(() => {
      this.countDown(reload, onCountEnd);
    }, 1000);

    this.clearTimeMethod = timer;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ countdownTime: nextProps.time });
  }

  componentWillUnmount() {
    clearInterval(this.clearTimeMethod);
  }

  countDown(reload, cb) {
    const { countdownTime } = this.state;
    let curtTime = countdownTime;

    // 兼容iosDate构造函数不识别'YYYY-MM-DD'的问题
    const data = util.getCountDown(util.exchangeTime(countdownTime), this.props.flag);
    const { date, hour, min, sec } = data;
    if (+date === 0 && +hour === 0 && +min === 0 && +sec === 0) {
      reload && window.location.reload();
      cb && cb();
    } else {
      if (typeof countdownTime == 'number') {
        curtTime = countdownTime - 1;
      }
    }

    this.setState({
      countdownTime: curtTime,
      ...data
    });
  }

  formatStr = (index) => {
    const { format = [] } = this.props;
    if (window.currentLng == 'cn') {
      return format[index];
    } else {
      if (index == format.length - 1) return '';
      return '';
    }
  };

  render() {
    // text表示输出只有文字的格式，没有白底框，format数组长度最长为4，分别渲染 '天时分秒' 的后缀部分
    const {
      className,
      text,
      colorType,
      format = [],
      disableHour = false,
      disableMin = false,
      disableSec = false
    } = this.props;
    const { hour, min, sec, date } = this.state;

    return (
      <Flex className={`common-count-down ${className} ${text ? '' : 'format'}`}>
        {this.props.flag ? (
          date > 0 ? (
            <React.Fragment>
              <span className={`date ${colorType}`}>{date}</span>
              <span className={`day ${colorType}`}>{this.formatStr(0) || '天'}</span>
            </React.Fragment>
          ) : null
        ) : null}
        {!disableHour && (
          <span className={`hour ${colorType} ${format.length >= 1 ? '' : 'dot'}`}>
            {hour}
            {this.formatStr(1) || ''}
          </span>
        )}
        {!disableMin && (
          <span className={`min ${colorType} ${format.length >= 1 ? '' : 'dot'}`}>
            {min}
            {this.formatStr(2) || ''}
          </span>
        )}
        {!disableSec && (
          <span className={`sec ${colorType} ${format.length >= 1 ? '' : 'dot'}`}>
            {sec}
            {this.formatStr(3) || ''}
          </span>
        )}
      </Flex>
    );
  }
}

module.exports = CountDown;



// WEBPACK FOOTER //
// ./src/pubBiz/CountDown/index.js